<template>
  <v-footer color="white">
    <v-container fluid id="footer-container">
      <v-row>
        <v-col class="footer-image-box" cols="12" md="3" lg="2">
          <v-row class="footer-image-box-text">
            <v-col cols="12">
              <VlaanderenLogo class="footer-image" />
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" md="9" lg="10">
          <v-row>
            <v-col cols="12">
              <strong>VEKA - {{ $t('app.title') }} - Versie: {{ $store.getters.appVersion }}</strong>
            </v-col>
          </v-row>
          <v-row class="col-12">
            <footer-link
              class="footer-link"
              href="https://www.vlaanderen.be/veka"
              :content="$t('links.over-veka')"
            ></footer-link>
            <hr
              aria-orientation="vertical"
              class="mx-2 my-auto v-divider v-divider--inset v-divider--vertical theme--light"
              style="height: 16px"
            />
            <footer-link
              class="footer-link"
              href="https://www.vlaanderen.be/veka/over-het-vlaams-energie-en-klimaatagentschap-veka/disclaimer"
              :content="$t('links.disclaimer')"
            ></footer-link>
            <hr
              aria-orientation="vertical"
              class="mx-2 my-auto v-divider v-divider--inset v-divider--vertical theme--light"
              style="height: 16px"
            />
            <footer-link
              class="footer-link"
              href="https://www.vlaanderen.be/veka/privacyverklaring"
              :content="$t('links.privacyverklaring')"
            ></footer-link>
            <hr
              aria-orientation="vertical"
              class="mx-2 my-auto v-divider v-divider--inset v-divider--vertical theme--light"
              style="height: 16px"
            />
            <footer-link
              class="footer-link"
              href="https://www.vlaanderen.be/over-vlaanderenbe/cookieverklaring-vlaanderenbe"
              :content="$t('links.cookieverklaring')"
            ></footer-link>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </v-footer>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';
import VlaanderenLogo from '@/components/layout/VlaanderenLogo.vue';
import FooterLink from '@/components/links/FooterLink.vue';

@Component({
  components: { FooterLink, VlaanderenLogo },
})
export default class Footer extends Vue {}
</script>
